(function () {
  var mapCache = {};
  var activeOverlay = null;

  function normalizeSku(sku) {
    return String(sku || '').trim().replace(/-(WKC|EKC)$/i, '').toUpperCase();
  }

  function getJson(script) {
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getVariantById(variants, id) {
    id = String(id || '');
    return variants.find(function (variant) {
      return String(variant.id) === id;
    });
  }

  function getCurrentVariant(root, variants, eventVariant) {
    if (eventVariant && eventVariant.id) {
      var fromEvent = getVariantById(variants, eventVariant.id);
      return fromEvent || eventVariant;
    }

    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    if (urlVariant) {
      var fromUrl = getVariantById(variants, urlVariant);
      if (fromUrl) return fromUrl;
    }

    var form = root.closest('.t4s-product-form__variants') || document;
    var input = form.querySelector('select[name="id"], input[name="id"]') || document.querySelector('select[name="id"], input[name="id"]');
    if (input && input.value) {
      var fromInput = getVariantById(variants, input.value);
      if (fromInput) return fromInput;
    }

    return variants[0] || null;
  }

  function loadMap(url) {
    if (!url) return Promise.resolve(null);
    if (!mapCache[url]) {
      mapCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Stock map unavailable');
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }
    return mapCache[url];
  }

  function verifyStock(match) {
    if (!match || !match.handle || !match.variantId) return Promise.resolve(null);

    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(rootUrl + 'products/' + match.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      })
      .then(function (product) {
        var target = (product.variants || []).find(function (variant) {
          return String(variant.id) === String(match.variantId);
        });

        return target && target.available ? match : null;
      })
      .catch(function () {
        return null;
      });
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (node) {
      node.textContent = value || '';
    });
  }

  function setLinks(root, url) {
    root.querySelectorAll('[data-zmy-stock-alt-link], [data-zmy-stock-alt-dialog-link]').forEach(function (node) {
      node.setAttribute('href', url || '#');
    });
  }

  function getSuppressedBaseSku(root) {
    return root.getAttribute('data-zmy-suppressed-base-sku') || '';
  }

  function suppressCurrentBaseSku(root, baseSku) {
    root.setAttribute('data-zmy-suppressed-base-sku', baseSku || '');
  }

  function resetSuppressionWhenSkuChanges(root, baseSku) {
    var previousBaseSku = root.getAttribute('data-zmy-active-base-sku') || '';
    if (baseSku !== previousBaseSku) {
      root.removeAttribute('data-zmy-suppressed-base-sku');
    }
    root.setAttribute('data-zmy-active-base-sku', baseSku || '');
  }

  function fillContent(root, match, currentVariant) {
    var warehouse = match.warehouse || 'US Stock';
    var note = match.inventoryQuantity && Number(match.inventoryQuantity) <= 2 ? ' - Limited stock available' : ' - In stock now';

    setText(root, '[data-zmy-stock-alt-warehouse]', warehouse);
    setText(root, '[data-zmy-stock-alt-warehouse-dialog]', warehouse);
    setText(root, '[data-zmy-stock-alt-sku]', match.sku || '');
    setText(root, '[data-zmy-stock-alt-stock-note]', note);
    setLinks(root, match.url);

    root.setAttribute('data-zmy-current-sku', currentVariant && currentVariant.sku ? currentVariant.sku : '');
    root.setAttribute('data-zmy-base-sku', normalizeSku(currentVariant && currentVariant.sku));
    root.setAttribute('data-zmy-stock-sku', match.sku || '');
  }

  function showNudge(root, shouldShow) {
    var nudge = root.querySelector('[data-zmy-stock-alt-nudge]');
    if (!nudge) return;
    nudge.hidden = !shouldShow;
  }

  function openDialog(root) {
    var overlay = root.querySelector('[data-zmy-stock-alt-overlay]');
    if (!overlay || !overlay.hidden) return;

    if (activeOverlay && activeOverlay !== overlay) {
      activeOverlay.hidden = true;
    }

    overlay.hidden = false;
    activeOverlay = overlay;
    document.documentElement.classList.add('zmy-stock-alt-open');

    var primary = overlay.querySelector('[data-zmy-stock-alt-dialog-link]');
    if (primary) {
      try {
        primary.focus({ preventScroll: true });
      } catch (error) {
        primary.focus();
      }
    }
  }

  function closeDialog(root, baseSku) {
    var overlay = root.querySelector('[data-zmy-stock-alt-overlay]');
    if (!overlay) return;
    overlay.hidden = true;
    activeOverlay = null;
    document.documentElement.classList.remove('zmy-stock-alt-open');
  }

  function init(root) {
    var variants = getJson(root.querySelector('[data-zmy-stock-alt-variants]'));
    if (!variants.length) return;

    var mapUrl = root.getAttribute('data-map-url');
    var activeBaseSku = '';
    var showTimer = null;

    root.querySelectorAll('[data-zmy-stock-alt-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        suppressCurrentBaseSku(root, activeBaseSku);
        closeDialog(root, activeBaseSku);
      });
    });

    var overlay = root.querySelector('[data-zmy-stock-alt-overlay]');
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          suppressCurrentBaseSku(root, activeBaseSku);
          closeDialog(root, activeBaseSku);
        }
      });
    }

    function update(eventVariant, delay) {
      window.clearTimeout(showTimer);

      var currentVariant = getCurrentVariant(root, variants, eventVariant);
      var baseSku = normalizeSku(currentVariant && currentVariant.sku);
      resetSuppressionWhenSkuChanges(root, baseSku);
      activeBaseSku = baseSku;

      if (!baseSku) {
        showNudge(root, false);
        closeDialog(root);
        return;
      }

      loadMap(mapUrl).then(function (map) {
        var match = map && map.items ? map.items[baseSku] : null;
        if (!match) {
          showNudge(root, false);
          closeDialog(root);
          return null;
        }

        return verifyStock(match).then(function (verifiedMatch) {
          if (!verifiedMatch || activeBaseSku !== baseSku) {
            showNudge(root, false);
            closeDialog(root);
            return;
          }

          fillContent(root, verifiedMatch, currentVariant);
          showNudge(root, true);

          if (getSuppressedBaseSku(root) !== baseSku) {
            showTimer = window.setTimeout(function () {
              if (activeBaseSku === baseSku && getSuppressedBaseSku(root) !== baseSku) {
                openDialog(root);
              }
            }, delay || 900);
          }
        });
      });
    }

    update(null, 1100);

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && (event.detail.variant || event.detail.currentVariant);
      update(variant, 300);
    });

    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document).on('variant:changed', function (event) {
        update(event.currentVariant, 300);
      });
    } else if (window.jQuery) {
      window.jQuery(document).on('variant:changed', function (event) {
        update(event.currentVariant, 300);
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-zmy-stock-alt-link], [data-zmy-stock-alt-dialog-link]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') {
        event.preventDefault();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !activeOverlay) return;
    var root = activeOverlay.closest('[data-zmy-stock-alt]');
    if (root) {
      var baseSku = root.getAttribute('data-zmy-base-sku') || '';
      suppressCurrentBaseSku(root, baseSku);
      closeDialog(root, baseSku);
    }
  });

  function boot() {
    document.querySelectorAll('[data-zmy-stock-alt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
